<template>
  <div class="layout-padding" :class="{'modalpage':page==='superpartner'}">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="팀 조회"
      desc="등록한 팀들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <!-- 기획전 상품 등록 버튼 -->
    <div class="btn-group-justify-end" v-if="page==='superpartner'">
      <button class="button is-primary" @click="selectGroup">팀 선택하기</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props" v-if="page=='superpartner'">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="type" slot-scope="props">
        <div v-if="props.item.type===0">비공개</div>
        <div v-else>공개</div>
      </div>

      <div slot="enable_approval_sign" slot-scope="props">
        <div v-if="props.item.enable_approval_sign">사용</div>
        <div v-else>사용안함</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <a :href="teamLink(props.item)" target="_blank">
          <button class="button half" style="margin-right:4px">팀 관리</button>
        </a>
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheck from "../../module/common/LpCheck";
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: 'GroupList',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    props: ['page', 'selectedItems'],
    components: {
      LpCheckBool,
      LpCheck

    },
    data () {
      return {
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('group', 'group');
        if(this.page === 'superpartner') {
          // 수퍼파트너 없을 경우 superpartner__isnull = true
          this.filtered.is_superpartner = true;
        }
        this.addField();
      },
      getDataFromServer() {
        this.getData();
      },
      teamLink(item) {
        return `${location.origin}/office/${this.$store.getters.mode}/group_admin/${item.id}/group/member`;
      },
      addField() {

        if(this.page === 'superpartner') {
          for(let i=0; i<this.tableData.length; i++){
            if(this.tableData[i].eng_name==='modify_delete') {
              this.tableData.splice(i, 1);
            }
          }
          if(this.tableData[0].eng_name !== 'checkspot') {
            this.tableData.splice(0, 0, {
              eng_name: 'checkspot',
              ko_name: '',
              width: '47px'
            });
          }
        }
      },
      clickModifyDelete(item, type) {
        if(type === 'delete') {
          let value = {
            url: `group/${item.id}`,
            title: '팀을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      // 수퍼파트너 팀 선택
      selectGroup() {
        let groupItems = [];
        let id_list = [];
        for(let i=0; i<this.showcaseCheckArr.length; i++){
          for(let j=0; j<this.tableItems.length; j++){
            if(this.showcaseCheckArr[i].value && this.showcaseCheckArr[i].id===this.tableItems[j].id){
              groupItems.push(this.tableItems[j]);
              id_list.push(this.tableItems[j].id);
            }
          }
        }
        this.$emit('groupItems', {
          groupItems: groupItems,
          id_list: id_list
        });
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .simple-desc
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

  .modalpage
    margin-top 50px
    padding: 1.25rem
</style>
